// Replaces js/src/template.js plus the two .html template files.
// Uses tagged template literals — no underscorify, no node-underscorify, no
// build-time preprocessing of HTML.

import { formTemplate } from './templates/form.js';
import { listingsTemplate } from './templates/listings.js';

// URL of the production stylesheet, kept identical to the legacy bundle so
// loadStyles() behaves the same when the embed is hosted on a third-party
// page that hasn't manually included the CSS.
const STYLE_URL = 'https://api.essilorusa.com/sales/sales-locator.css';

export function buildFinder() {
  const host = document.querySelector('.traffic-express');
  if (!host) {
    if (window.console && console.warn) {
      console.warn('sales-locator: no `.traffic-express` host element found on the page.');
    }
    return;
  }
  host.innerHTML = formTemplate();
}

export function loadStyles() {
  // Idempotent: don't add the link twice.
  if (document.querySelector(`link[data-sales-locator-styles]`)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = STYLE_URL;
  link.dataset.salesLocatorStyles = 'true';
  document.head.appendChild(link);
}

export function buildList(data) {
  const target = document.querySelector('.locations-listings');
  if (!target) return;
  target.innerHTML = listingsTemplate(data);
}
